import { useHotkeys } from 'react-hotkeys-hook';

export type HotKeyTriggerProps = {
  hotkey: string;
  action?: () => void | Promise<void>;
  description?: string;
};

export function HotKeyTrigger({ hotkey, action }: HotKeyTriggerProps) {
  useHotkeys(
    hotkey,
    (event) => {
      event.preventDefault();
      void action?.();
    },
    { preventDefault: true },
    [action],
  );
  return null;
}
